<template>
	<b-col class="simple-card" :style="{ background: background }">
		<span class="title">{{ title }}</span>
		<span class="value">{{ value }}</span>
	</b-col>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
			default: 'No Title'
		},
		value: {
			type: Number,
			default: 0
		},
		background: {
			type: String,
			default: '#4F362D'
		}
	}
}
</script>
